import React, { useState } from 'react';
import './TextInput.css';

const TextInput = ({
  label,
  required,
  value,
  onChange,
  placeholder,
  error,
  inputClassName,
  isDisabled,
  fieldType,
  caseType,
  name,
  minLength,
  maxLength,
}) => {
  const [localError, setLocalError] = useState('');
  const [isTouched, setIsTouched] = useState(false);

  // Validation patterns
  const patterns = {
    gst: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
    ifsc: /^[A-Z]{4}0[A-Z0-9]{6}$/,
    pan: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
  };

  const handleInputChange = (e) => {
    let inputValue = e.target.value;
    let errorMessage = '';

    // Apply case conversion
    if (caseType === 'uppercase') {
      inputValue = inputValue.toUpperCase();
    } else if (caseType === 'lowercase') {
      inputValue = inputValue.toLowerCase();
    }

    // Input sanitization based on field type
    switch (fieldType) {
      case 'number':
        inputValue = inputValue.replace(/[^0-9]/g, '');
        break;
      case 'alphabet':
        inputValue = inputValue.replace(/[^A-Za-z\s]/g, '');
        break;
      case 'alphanumeric':
        inputValue = inputValue.replace(/[^A-Za-z0-9\s]/g, '');
        break;
      case 'gst':
        inputValue = inputValue.replace(/[^0-9A-Z]/g, '').toUpperCase();
        inputValue = inputValue.slice(0, 15);
        break;
      case 'ifsc':
        inputValue = inputValue.replace(/[^A-Z0-9]/g, '').toUpperCase();
        inputValue = inputValue.slice(0, 11);
        break;
      case 'pan':
        inputValue = inputValue.replace(/[^A-Z0-9]/g, '').toUpperCase();
        inputValue = inputValue.slice(0, 10);
        break;
      default:
        break;
    }

    // Clear any error if there's a value
    if (inputValue.trim().length > 0) {
      errorMessage = '';
    }
    // Show required error only if field is touched and empty
    else if (required && isTouched) {
      errorMessage = 'This field is required';
    }

    // Validate special formats only if there's a value
    if (inputValue) {
      switch (fieldType) {
        case 'gst':
          if (inputValue.length === 15 && !patterns.gst.test(inputValue)) {
            errorMessage = 'Invalid GST format. Example: 29ABCDE1234F1Z5';
          }
          break;
        case 'ifsc':
          if (inputValue.length === 11 && !patterns.ifsc.test(inputValue)) {
            errorMessage = 'Invalid IFSC format. Example: SBIN0123456';
          }
          break;
        case 'pan':
          if (inputValue.length === 10 && !patterns.pan.test(inputValue)) {
            errorMessage = 'Invalid PAN format. Example: ABCDE1234F';
          }
          break;
        case 'account_no':
          if (inputValue.length > 0 && (inputValue.length < 12 || inputValue.length > 18)) {
            errorMessage = 'Account Number should be 12 to 18 digits';
          }
          break;
        default:
          break;
      }
    }

    setLocalError(errorMessage);

    // Create synthetic event with the processed value and error
    const syntheticEvent = {
      target: {
        name,
        value: inputValue,
        error: errorMessage,
      },
    };

    onChange(syntheticEvent);
  };

  const handleBlur = () => {
    setIsTouched(true);
    // Show required error on blur if field is empty
    if (required && !value.trim()) {
      setLocalError('This field is required');
    }
  };

  // Handle initial mount - if there's an external error, mark as touched
  React.useEffect(() => {
    if (error) {
      setIsTouched(true);
    }
  }, [error]);

  return (
    <div className="form-group">
      <label>
        {label} {required && <span style={{ color: 'red' }}>*</span>}
      </label>
      <input
        type="text"
        name={name}
        value={value}
        onChange={handleInputChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        className={`text-input ${(error || localError) ? 'error' : ''} ${isDisabled ? 'isDisabled' : ''} ${inputClassName || ''}`}
        disabled={isDisabled}
        maxLength={maxLength || (fieldType === 'gst' ? 15 : fieldType === 'ifsc' ? 11 : undefined)}
        autoComplete="new-password"
      />
      {((error || localError) && isTouched) && (
        <div className="error-message">{error || localError}</div>
      )}
    </div>
  );
};

export default TextInput;